import { Component, Inject } from '@angular/core';
import { ENV, Environment } from 'src/environments/environment.provider';
import { formatAppVersion } from '../../services/version-checker.service';

@Component({
    selector: 'nova-version',
    standalone: true,
    templateUrl: './version.component.html'
})
export class VersionComponent {
    readonly currentAppVersion = this.env.production
        ? formatAppVersion(this.env.appVersion).replace(/-\d*$/, '')
        : formatAppVersion(this.env.appVersion);
    readonly currentAppVersionFull = formatAppVersion(this.env.appVersion);

    constructor(@Inject(ENV) private readonly env: Environment) {}
}
